var navArr = [
    {
      title: "首页",
      path: "/homeIndex",
    },
    {
      title: "关于我们",
      path: "/gywm",
      children: [
        {
          title: "创新院简介",
          path: "/jianjie?article_id=756081535927042048",
        },
        {
          title: "组织框架",
          path: "/zzkj?article_id=755806156456837120",
        },
        {
          title: "现任领导",
          path: "/xrld?column_id=753617779888340992",
        },
        {
          title: "发展历史",
          path: "/fzls?article_id=756083945487581184",
        },
      ]
    },
    // {
    //   title: "关于我们",
    //   path: "/gywm",
    //   children: [
    //     {
    //       title: "简介",
    //       path: "/jianjie?article_id=756081535927042048",
    //     },
    //     {
    //       title: "组织框架",
    //       path: "/zzkj?article_id=755806156456837120",
    //     },
    //     {
    //       title: "发展历史",
    //       path: "/fzls?article_id=756083945487581184",
    //     },
    //     {
    //       title: "联系我们",
    //       path: "/lxwm?article_id=756082358690103296",
    //     },
    //   ]
    // },
    {
      title: "科学研究",
      path: "/kxyj",
      children: [
        {
          title: "科研动态",
          path: "/kydt?column_id=751103586014445568",
        },
        {
          title: "科研项目",
          path: "/kyxm?column_id=751103920296280064",
        },
        {
          title: "专利与获奖",
          path: "/zlyhj?column_id=753615077905121280",
        },
        {
          title: "论文论著",
          path: "/lwlz?column_id=751104021865545728",
        },
        // {
        //   title: "自主课题",
        //   path: "/zzkt?column_id=751104124529524736",
        // },
        {
          title: "科普专栏",
          path: "/kpzl?column_id=751104248462819328",
        },
      ]
    },
    {
      title: "队伍建设",
      path: "/dwjs",
      children: [
        {
          title: "科研团队",
          path: "/kytd",
        },
        // {
        //   title: "管理机构",
        //   path: "/gljg",
        // },
        {
          title: "导师队伍",
          path: "/dsdw?column_id=751110310523944960",
        },
        {
          title: "博士后",
          path: "/bshrc?column_id=751110474995187712",
        },
        {
          title: "人事招聘",
          path: "/rszp",
        },
      ]
    },
    {
      title: "党建工作",
      path: "/djgz?column_id=762247419442585600",
      children: []
    },
    {
      title: "人才培养",
      path: "/rcpy",
      children: [
        {
          title: "研究生风采",
          path: "/yjsfc?column_id=756814689499463680",
        },
        {
          title: "创新创业",
          path: "/cxcy?column_id=751110883419734016",
        },
        // {
        //   title: "学生组织",
        //   path: "/xszz?column_id=756815095248044032",
        // },
        // {
        //   title: "奖励资助",
        //   path: "/jlzz?column_id=751110979196665856",
        // },
      ]
    },
    {
      title: "开放交流",
      path: "/kfjl",
      children: [
        {
          title: "论坛讲座",
          path: "/jzbg?column_id=751111181416644608",
        },
        // {
        //   title: "论坛",
        //   path: "/lt?column_id=751111365630476288",
        // },
        // {
        //   title: "路演",
        //   path: "/ly?column_id=751110979196665856",
        // },
        {
          title: "合作伙伴",
          path: "/hzhb?column_id=751111459826155520",
        },
        {
          title: "承办会议",
          path: "/cbhy?column_id=751111554558705664",
        },
      ]
    },
    {
      title: "运行管理",
      path: "/yxgl",
      children: [
        {
          title: "理事会",
          path: "/lsh",
        },
        // {
        //   title: "学术委员会",
        //   path: "/xswyh",
        // },
        // {
        //   title: "战略咨询委员会",
        //   path: "/zlzxwyh",
        // },
        // {
        //   title: "领导班子",
        //   path: "/ldbz?column_id=753617779888340992",
        // },
        {
          title: "首席科学家",
          path: "/sxkxj?column_id=756817450236493824",
        },
        // {
        //   title: "智库",
        //   path: "/zk?column_id=756818809035800576",
        // }
        // {
        //   title: "管理制度",
        //   path: "/glzd",
        // },
      ]
    },
    {
      title: "平台建设",
      path: "/ptjs",
      children: [
        // {
        //   title: "平台概况",
        //   path: "/ptgk?column_id=753618953295216640",
        // },
        {
          title: "水产南繁种业创新中心",
          path: "/scnfzzcxzx?column_id=760928744282349568",
        },
        {
          title: "热带海洋生态与蓝碳中心",
          path: "/rdhystyltzx?column_id=760929859325485056",
        },
        {
          title: "深海探测与装备中心",
          path: "/shtcyzbzx?column_id=760930071406272512",
        },
        {
          title: "智能试验场与数字南海中心",
          path: "/znsycysznhzx?column_id=760930187458469888",
        },
        {
          title: "南海资源开发与工程环境研究所",
          path: "/gnyzpt?column_id=753631045918244864",
        },
        // {
        //   title: "大型仪器设备",
        //   path: "/dxyqsb?column_id=753631142722781184",
        // },
      ]
    },
  ]
  export default navArr